<div class="sidenav">
  <wk-sidenav-header (toggleNavBar)="toggleClick()"></wk-sidenav-header>

  <div class="section-sub-actions">
    <div *ngFor="let group of groups; trackBy: trackById" class="section">
      <mat-list-item *ngFor="let item of group.items; trackBy: trackById">
        <ng-container *ngIf="!item.component">
          <app-expand-menu [item]="item"></app-expand-menu>
        </ng-container>
        <ng-container *ngIf="item.component">
          <adf-dynamic-component
            [data]="{ item: item, state: 'expanded' }"
            [id]="item.component"
          ></adf-dynamic-component>
        </ng-container>
      </mat-list-item>
    </div>
  </div>
</div>
